import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

/**
 * BentoCard - Consistent card for the bottom bento grid row.
 * Structure: Header | Info | Items (with anchored expand button)
 * 
 * Always renders all three sections for consistent sizing across cards.
 */
function BentoCard({
  icon,
  title,
  headerVariant = '',
  headerRight,
  info,
  children,
  items,
  renderItem,
  collapseAt = 3,
  expanded = false,
  onToggleExpand,
  emptyState,
  className = ''
}) {
  const hasItems = items && items.length > 0;
  const needsExpand = hasItems && items.length > collapseAt;
  const displayedItems = hasItems
    ? (expanded ? items : items.slice(0, collapseAt))
    : [];

  return (
    <div className={`bento-card ${expanded ? 'expanded' : ''} ${className}`}>
      {/* HEADER */}
      <div className={`bento-card-header ${headerVariant}`}>
        <div className="bento-card-title">
          {icon}
          <span>{title}</span>
        </div>
        {headerRight}
      </div>

      {/* INFO - always rendered for consistent height */}
      <div className={`bento-card-info ${info ? 'has-content' : ''}`}>
        {info}
      </div>

      {/* ITEMS - list + anchored expand button */}
      <div className="bento-card-items">
        <div className="bento-card-items-list">
          {children ? (
            children
          ) : hasItems ? (
            displayedItems.map(renderItem)
          ) : emptyState ? (
            emptyState
          ) : null}
        </div>
        {needsExpand && onToggleExpand && (
          <button className="bento-card-expand" onClick={onToggleExpand}>
            {expanded
              ? <><ChevronUp size={14} /> Show less</>
              : <><ChevronDown size={14} /> Show {items.length - collapseAt} more</>
            }
          </button>
        )}
      </div>
    </div>
  );
}

export default BentoCard;
